/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/boolean-prop-naming */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_MenuFilters
 * @author      Deniss Strombergs <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import { DESKTOP_MIN_WIDTH } from 'Component/CategorySort/CategorySort.config';
import ExpandableContent from 'Component/ExpandableContent';
import { CategoryTreeType } from 'Type/Category.type';
import isMobile from 'Util/Mobile';

import './MenuFilters.style';

/** @namespace Scandipwa/Component/MenuFilters/Component */
export class MenuFiltersComponent extends PureComponent {
    static propTypes = {
        category: CategoryTreeType.isRequired,
        getRenderingData: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        menuFiltersHeight: PropTypes.number,
        setMenuFiltersHeight: PropTypes.func.isRequired,
        areComponentsLoading: PropTypes.bool.isRequired,
        filterTitle: PropTypes.string.isRequired,
        isSearchPage: PropTypes.bool.isRequired
    };

    static defaultProps = {
        menuFiltersHeight: undefined
    };

    state = {
        isDesktop: false
    };

    menuFiltersRef = createRef();

    renderSubcategory = this.renderSubcategory.bind(this);

    renderSubsubcategory = this.renderSubsubcategory.bind(this);

    updateWindowDimensions = this.updateWindowDimensions.bind(this);

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentDidUpdate() {
        const { menuFiltersHeight, setMenuFiltersHeight } = this.props;

        if (this.menuFiltersRef.current && this.menuFiltersRef.current.clientHeight !== menuFiltersHeight) {
            setMenuFiltersHeight(this.menuFiltersRef.current.clientHeight);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        const { isDesktop } = this.state;
        const newIsDesktop = (window.innerWidth >= DESKTOP_MIN_WIDTH);

        if (isDesktop !== newIsDesktop) {
            this.setState({ isDesktop: newIsDesktop });
        }
    }

    renderSubcategory(subcategory) {
        const {
            title,
            children = []
        } = subcategory;

        if (!children.length) {
            return null;
        }

        return (
            <ExpandableContent
              key={ title }
              heading={ title }
              mix={ {
                  block: 'MenuFilters',
                  elem: 'Expandable'
              } }
              isContentExpanded={ false }
              isNoContentDisplay
              hasClickOutside={ !isMobile.any() }
            >
                { children.map(this.renderSubsubcategory) }
            </ExpandableContent>
        );
    }

    renderSubsubcategory(category, index) {
        const {
            title, url, isActive, id
        } = category;
        const { onClick } = this.props;

        return (
            <div
              key={ index }
              block="MenuFilters"
              elem="LinkWrapper"
            >
                <button
                  block="MenuFilters"
                  elem="Link"
                  // eslint-disable-next-line react/jsx-no-bind
                  onClick={ () => onClick(url, id) }
                  mods={ { isSelected: isActive } }
                >
                    { title }
                </button>
            </div>
        );
    }

    renderSubcategories(renderingData) {
        if (!renderingData || renderingData.length === 0) {
            return null;
        }

        return renderingData.map(((subcategory) => this.renderSubcategory(subcategory)));
    }

    renderCategoriesPlaceholders() {
        // eslint-disable-next-line no-magic-numbers
        const sizes = [5, 4, 10, 8, 11];

        return sizes.map((item, index) => (
            <li
              // eslint-disable-next-line react/no-array-index-key
              key={ index }
              block="MenuFilter"
              elem="Item"
            >
                <div block="MenuFilter" elem="ItemName">
                    { 'A'.repeat(item) }
                </div>
            </li>
        ));
    }

    renderPlaceholder() {
        return (
            <div
              block="MenuFilters"
              elem="MenuFiltersPlaceholders"
              mods={ { isLoading: true } }
            >
                <div
                  block="MenuFilters"
                  elem="MainCategories"
                >
                    <ul
                      block="MenuFilters"
                      elem="ItemList"
                    >
                        { this.renderCategoriesPlaceholders() }
                    </ul>
                </div>
            </div>
        );
    }

    render() {
        const {
            getRenderingData,
            areComponentsLoading,
            filterTitle,
            isSearchPage
        } = this.props;
        const { isDesktop } = this.state;
        const renderingData = getRenderingData();

        if (!renderingData && !isDesktop) {
            return null;
        }

        if ((!renderingData && isDesktop) || areComponentsLoading) {
            return this.renderPlaceholder();
        }

        return (
            <div
              block="MenuFilters"
              ref={ this.menuFiltersRef }
            >
                { filterTitle && !isSearchPage && <h2 block="CategoryFilterOverlay" elem="Heading">{ filterTitle }</h2> }
                { this.renderSubcategories(renderingData) }
            </div>
        );
    }
}

export default MenuFiltersComponent;
